module.exports = __webpack_public_path__ + "static/media/04-Knightsbridge.14cf76c2.mp4";